import { render, staticRenderFns } from "./ScaleCard.vue?vue&type=template&id=b64aae98&"
import script from "./ScaleCard.vue?vue&type=script&lang=js&"
export * from "./ScaleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports